import Model from './AdminBaseModel'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default class Address extends Model {
  resource() {
    return 'address'
  }
}
